import Btn from '../utils/btn';

const func = $target => {
	var $form = $target,
		$token = $form.find('[name*="gatewayToken"]'),
		$nonce = $form.find('[name*="nonce"]'),
		amount = $form.find('[name*="amount"]').val(),
		currency = $form.find('[name*="currency"]').val(),
		email = $form.find('[name*="email"]').val(),
		address = JSON.parse($form.find('[name*="address"]').val()),
		$dropinUi = $form.find('[data-id="dropInUi"]'),
		$submit = new Btn($form.find('button[type="submit"]'));

	if ($dropinUi[0]) {

		window.loader.key('braintree-dropinUI', function() {
			$submit.process();
			if ($submit.data('loading')) {
				$submit.text($submit.data('loading'));
			}

			var options = {
				authorization: $token.val(),
				container: $dropinUi[0],
				locale: $dropinUi.data('locale'),
				vaultManager: $dropinUi.data('manage'),
				card: {
					cardholderName: {
						required: true
					},
					vault: {
						vaultCard: true,
						allowVaultCardOverride: true,
					}
				}
			};

			let subscriptionOrder = Boolean($dropinUi.attr('data-subscription'));

			if (subscriptionOrder != true) {
				options.applePay = {
					displayName: $dropinUi.data('name'),
					paymentRequest: {
						total: {
							label: $dropinUi.data('name'),
							amount: amount
						}
					}
				};

				options.googlePay = {
					displayName: $dropinUi.data('name'),
					paymentRequest: {
						total: {
							label: $dropinUi.data('name'),
							amount: amount
						}
					}
				};
			} else {
				options.card.vault.allowVaultCardOverride = false;
			}

			options.paypal = {
				flow: subscriptionOrder == true ? 'vault' : 'checkout' ,
				env: $dropinUi.attr('data-sandbox') ? 'sandbox' : 'production',
				amount: amount,
				currency: currency,
				vault: {
					vaultPayPal: subscriptionOrder,
				},
				buttonStyle: {
					color: 'blue',
					shape: 'rect',
					size: 'responsive',
					label: 'paypal',
				},
			};

			if ($dropinUi.data('threedsecure')) {
				options.threeDSecure = true;

				var threeDSecureOptions = {
					amount: amount,
					email: email,
					billingAddress: address,
					challengeRequested: true,
				};
			}

			braintree.dropin.create(options, function(err, dropinInstance) {
				if (err) {
					console.error(err);
					if (window.braintreeError) {
						window.braintreeError(err);
					}
					return;
				}
				//reset($submit);
				$submit.resetText();
				$submit.processed();

				if (dropinInstance.isPaymentMethodRequestable()) {
					//reset($submit);
					//console.log('isPaymentMethodRequestable');
				}
				//need for vault
				dropinInstance.on('paymentMethodRequestable', function(e) {
					//reset($submit);
					//console.log('paymentMethodRequestable');
					$submit.enable();
				});
				dropinInstance.on('noPaymentMethodRequestable', function(e) {
					//processing($submit);
					//console.log('noPaymentMethodRequestable');
					$submit.disable();
				});
				dropinInstance.on('paymentOptionSelected', function(e) {
					//$submit.prop('disabled', false);
					//console.log('paymentOptionSelected');
				});

				$form.on('submit', {
					dropinInstance: dropinInstance,
					threeDSecure: $dropinUi.data('threedsecure'),
					threeDSecureOptions: threeDSecureOptions
				}, formSubmit);
			});
		});
	}

	function formSubmit(e) {
		e.preventDefault();
		//console.log(e)
		var dropinInstance = e.data.dropinInstance,
			$form = $(e.currentTarget),
			threeDSecure = e.data.threeDSecure,
			threeDSecureOptions = e.data.threeDSecureOptions;
			
		//$submit = $form.find('button[type="submit"]');
		//processing($submit);
		$submit.process();

		var options = {
			threeDSecure: threeDSecureOptions
		}

		dropinInstance.requestPaymentMethod(threeDSecure ? options : {}, function(err, payload) {
			if (err) {
				console.error(err);
				if (window.braintreeError) {
					window.braintreeError(err);
				}
				//reset($submit);
				$submit.processed();
				return;
			}
			//console.log(payload);
			if ((payload.liabilityShiftPossible && payload.liabilityShifted) || !payload.liabilityShiftPossible || payload.type !== 'CreditCard' || !threeDSecure) {
				//processing($submit);
				$submit.process();
				$form.find('input[name*=nonce]').val(payload.nonce);
				$form.find('input[name*=type]').val(payload.type);
				$form.off('submit', formSubmit);
				$form.submit();
			} else {
				if (window.braintreeError) {
					window.braintreeError('3ds failed');
				}
				//dropinInstance.clearSelectedPaymentMethod();
				//reset($submit);
				$submit.processed();
				//$submit.prop('disabled', true);
			}
		});
	}
	/*function reset($button) {
		$button.prop('disabled', false);
		$button.text($button.data('text'));
	}
	function processing($button) {
		$button.prop('disabled', true);
		if ($button.data('processing')) {
			$button.text($button.data('processing'));
		}
	}*/
};

export default func;
